import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';
import { APP_NAME, STORAGE_PREFIX } from '@/lib/brand';
import { trackEvent } from '@/lib/analytics';

export function OnboardingPage() {
  const navigate = useNavigate();
  const [splashStep, setSplashStep] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setSplashStep(1), 300),
      setTimeout(() => setSplashStep(2), 1000),
      setTimeout(() => setSplashStep(3), 1600),
      setTimeout(() => setSplashStep(4), 2800),
      setTimeout(() => {
        localStorage.setItem(`${STORAGE_PREFIX}-onboarded`, 'true');
        trackEvent('onboarding_complete');
        navigate('/dashboard', { replace: true });
      }, 3500),
    ];
    return () => timers.forEach(clearTimeout);
  }, [navigate]);

  return (
    <div
      className={`dark min-h-screen bg-gradient-to-br from-[#1a3a15] via-[#275420] to-[#1e3f18] flex flex-col items-center justify-center relative overflow-hidden transition-opacity duration-700 ${
        splashStep >= 4 ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-green-400/10 rounded-full blur-[100px] splash-glow" />
      </div>

      <div
        className={`relative z-10 transition-all duration-[800ms] ${
          splashStep >= 1 ? 'opacity-100 scale-100' : 'opacity-0 scale-[0.6]'
        }`}
        style={{ transitionTimingFunction: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }}
      >
        <div className="w-28 h-28 bg-overlay-3 backdrop-blur-md rounded-[28px] flex items-center justify-center shadow-2xl border border-line">
          <GraduationCap className="w-16 h-16 text-fg" />
        </div>
      </div>

      <h1
        className={`mt-8 text-4xl font-bold text-fg tracking-tight transition-all duration-700 ease-out ${
          splashStep >= 2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
        }`}
      >
        {APP_NAME}
      </h1>

      <p
        className={`mt-3 text-fg-subtle text-sm tracking-widest transition-all duration-700 ease-out ${
          splashStep >= 3 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'
        }`}
      >
        Apprendre · Pratiquer · Réussir
      </p>

      <div
        className={`absolute bottom-16 w-40 h-[3px] bg-overlay-3 rounded-full overflow-hidden transition-opacity duration-500 ${
          splashStep >= 1 ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div className="h-full bg-gradient-to-r from-green-400/60 to-emerald-300/60 rounded-full splash-progress" />
      </div>
    </div>
  );
}
